/**
 * translateCrashGuard — blindagem contra o crash React × mutação de DOM externa.
 *
 * Erro alvo: "NotFoundError: Failed to execute 'removeChild' on 'Node': The node
 * to be removed is not a child of this node" (e o equivalente em insertBefore).
 *
 * Causa: tradução automática do navegador (Google Tradutor) e algumas extensões
 * reescrevem nós de texto/DOM por fora do React. Quando o React depois desmonta
 * um trecho (diálogos Radix via portal, toasts sonner), o nó já não está onde ele
 * espera e `removeChild`/`insertBefore` lançam — derrubando a árvore (tela branca).
 *
 * Solução: tornar esses dois métodos tolerantes — quando o nó não é filho do pai
 * esperado, falhar de forma graciosa em vez de lançar. No caminho normal, chama o
 * original sem efeito colateral. Ref: facebook/react#11538.
 *
 * Importar como PRIMEIRA linha de main.tsx (antes do React montar).
 * Documentação: docs/removechild-translate-crash.md
 */

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[translateGuard] removeChild ignorado: nó não é filho deste pai', child)
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[translateGuard] insertBefore: ref não é filho — usando append', referenceNode)
      }
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}

export {}
